import {Component, OnInit, Input, ChangeDetectionStrategy} from '@angular/core';
import {ProductDetailsService} from "../../../services/product-details.service";
import {Pos} from "../../../model/PosModel";
import {Subject} from "rxjs";

@Component({
  selector: 'v-product-section-availability',
  templateUrl: './product-section-availability.component.html',
  styleUrls: ['./product-section-availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSectionAvailabilityComponent implements OnInit {
  @Input() storeFinderTowns: string[];
  @Input() availableOnline: boolean;
  @Input() productCode: string;
  @Input() site;
  poses$ = new Subject<Pos[]>;
  town = '';

  constructor(private productDetailsService: ProductDetailsService) { }

  ngOnInit(): void {
  }

  selectTown(ev) {
    this.town = ev;

    this.productDetailsService.getAvailability({code: this.productCode, town: this.town}).subscribe(poses => {
      this.poses$.next(poses)
    });
  }

  isAvailable(data) {
    return data ? 'productDetails.availability.available' : 'productDetails.availability.unavailable';
  }
}
